import { render } from "./MapDetails.vue?vue&type=template&id=3595d364"
import script from "./MapDetails.vue?vue&type=script&lang=js"
export * from "./MapDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__